import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, HomeIcon, FileTextIcon } from 'lucide-react';
const painPoints = [{
  icon: AlertCircleIcon,
  title: 'NESIGURANȚĂ',
  subtitle: 'FRICI · AMENINȚĂRI · DREPTURI NECUNOSCUTE',
  image: 'https://images.unsplash.com/photo-1516534775068-ba3e7458af70?w=600&h=250&fit=crop',
  text: 'Soțul îți spune că nu vei obține nimic, că el cunoaște legea mai bine și că tu vei rămâne cu mâinile goale. Și tu îl crezi, pentru că nu știi ce îți garantează de fapt legea. Trăiești cu frici care în proporție de 99% nu sunt reale, dar nimeni nu ți-a spus asta clar.'
}, {
  icon: HomeIcon,
  title: 'COPIII ȘI CASA',
  subtitle: 'CUSTODIE · LOCUINȚĂ · PENSIE ALIMENTARĂ',
  image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=600&h=250&fit=crop',
  text: 'Nu știi dacă poți rămâne în casa în care locuiești cu copiii sau dacă trebuie să pleci. Nu știi cât poți cere pensie de întreținere și nici dacă instanța îți va lăsa copiii. Toate acestea au răspunsuri clare în lege, iar răspunsul la majoritatea fricilor tale te va surprinde.'
}, {
  icon: FileTextIcon,
  title: 'BLOCAT ÎN DOSAR',
  subtitle: 'MOȘTENIRI · EXECUTĂRI · PROCESE PENALE',
  image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&h=250&fit=crop',
  text: 'Ai un dosar deschis și nu înțelegi ce se întâmplă, ce acte sunt depuse sau ce urmează. Sau ai pierdut un apropiat și nu știi cum să faci succesiunea fără să apară conflicte. Sau cineva nu respectă o hotărâre judecătorească și nu știi ce poți face.'
}];
export function PainPointsSection() {
  return <section className="bg-cream py-20 px-6" data-id="element-246">
      <div className="max-w-7xl mx-auto" data-id="element-247">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-text-dark font-heading text-4xl md:text-5xl font-bold text-center mb-16" data-id="element-248">
          Te regăsești în <span className="text-gold" data-id="element-249">cel puțin una</span> din
          aceste situații?
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-250">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-lg overflow-hidden border-l-[3px] border-emerald shadow-[0_4px_20px_rgba(12,35,64,0.08)]" data-id="element-251">
              <div className="relative h-36 overflow-hidden" data-id="element-252">
                <img src={point.image} alt={point.title} className="w-full h-full object-cover" data-id="element-253" />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white/80" data-id="element-254"></div>
              </div>

              <div className="p-8 -mt-4 relative z-10" data-id="element-255">
                <point.icon className="w-10 h-10 text-emerald mb-4" strokeWidth={1.5} data-id="element-256" />
                <h3 className="font-label text-sm uppercase tracking-label text-text-dark mb-2" data-id="element-257">
                  {point.title}
                </h3>
                <p className="font-label text-xs uppercase tracking-label text-text-dark-secondary mb-4 opacity-70" data-id="element-258">
                  {point.subtitle}
                </p>
                <p className="font-body text-base text-text-dark-secondary leading-relaxed" data-id="element-259">
                  {point.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}